import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;
const config = {
  'Content-Type': 'application/json'
};

const getHeaderData = async () => {
  return axios.get(`${baseUrl}/orders/v1/headerData`);
};

const getCompanyData = async () => {
  return axios.get(`${baseUrl}/orders/v1/company`);
};

const getSideImage = async () => {
  return axios.get(`${baseUrl}/orders/v1/pageImage`);
};

const getProductList = async () => {
  return axios.get(`${baseUrl}/orders/v1/products`);
};

const getLocationList = async () => {
  return axios.get(`${baseUrl}/orders/v1/locations`);
};

const getDates = async id => {
  return axios.get(`${baseUrl}/orders/v1/dates/${id}`);
};

const getPayMethods = async id => {
  return axios.get(`${baseUrl}/orders/v1/payModes/${id}`);
};

const getTimes = async id => {
  return axios.get(`${baseUrl}/orders/v1/times/${id}`);
};

const sendOrder = async request => {
  return axios.post(`${baseUrl}/orders/v1/order`, request);
};

const getTerms = async () => {
  return axios.get(`${baseUrl}/orders/v1/agreement`);
};

const getFooterData = async () => {
  return axios.get(`${baseUrl}/orders/v1/footerData`);
};

const getCategoryList = async () => {
  return axios.get(`${baseUrl}/orders/v1/productCategories`);
};

const onlinePayment = async request => {
  return axios.post(`${baseUrl}/payment/v1/pay`, request);
};

const getSimpleStatus = async request => {
  return axios.get(`${baseUrl}/payment/v1/getSimpleStatus`);
};

const getPaymentGwData = async () => {
  return axios.post(
    `${baseUrl}/payment/v1/merchant`,
    {
      url: window.location.origin
    },
    config
  );
};

const checkTax = async tax => {
  return axios.get(`${baseUrl}/orders/v1/check/${tax}`);
};

const getSetting = async type => {
  return axios.get(`${baseUrl}/orders/v1/setting/${type}`);
};

const services = {
  getHeaderData,
  getCompanyData,
  getSideImage,
  getProductList,
  getLocationList,
  getDates,
  getPayMethods,
  getTimes,
  getTerms,
  sendOrder,
  getFooterData,
  getCategoryList,
  onlinePayment,
  getSimpleStatus,
  getPaymentGwData,
  checkTax,
  getSetting,
};

export default services;
